import { render, staticRenderFns } from "./comp-layout.vue?vue&type=template&id=0a0e5dba&scoped=true&lang=pug&"
import script from "./comp-layout.vue?vue&type=script&lang=js&"
export * from "./comp-layout.vue?vue&type=script&lang=js&"
import style0 from "./comp-layout.vue?vue&type=style&index=0&id=0a0e5dba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0e5dba",
  null
  
)

export default component.exports